/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  FaNetworkWired,
  FaServer,
  FaShieldAlt,
  FaCloud,
  FaRobot,
} from "react-icons/fa";

import abo1 from "../image/Image _ Page/Service_page/Data Center Virtualization & Computing.jpeg";
import abo2 from "../image/Image _ Page/Service_page/Enterprise Networking.jpeg";
import abo3 from "../image/Image _ Page/Service_page/Cybersecurity Solutions.jpeg";
import abo4 from "../image/Image _ Page/Service_page/Cloud & Applications.jpeg";
import abo5 from "../image/Image _ Page/Service_page/Managed Services.jpeg";
import abo6 from "../image/Image _ Page/Service_page/Physical Infrastructure Solutions.jpeg";
import img3 from "../image/Image _ Page/Service_page/Buttom_image.jpeg";
import ".././Components/style/serviceslide.css"

const Service = () => {
  const images = [abo1, abo2, abo3, abo4, abo5, abo6];
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Handle opening the dialog
  const openDialog = (image) => {
    setSelectedImage(image);
    setIsDialogOpen(true);
  };

  // Handle closing the dialog
  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedImage(null);
  };

  // Solutions carousel data — matches the ref layout (icon, title, description)
  const solutionCards = [
    {
      icon: <FaNetworkWired size={40} />,
      title: "Networking Solution",
      link: "/solution/Networking-solution",
      description:
        "Reliable, secure, and scalable network infrastructure to keep your business seamlessly connected.",
    },
    {
      icon: <FaServer size={40} />,
      title: "Infrastructure Solution",
      link: "/solution/Infastructure-solution",
      description:
        "Robust data center and server solutions built to support performance, growth, and uptime.",
    },
    {
      icon: <FaShieldAlt size={40} />,
      title: "CyberSecurity Solution",
      link: "/solution/CyberSecurity-solution",
      description:
        "Advanced protection for your systems and data against today's most sophisticated threats.",
    },
    {
      icon: <FaCloud size={40} />,
      title: "Cloud Solution",
      link: "/solution/Cloud-solution",
      description:
        "Flexible, secure cloud migration and management to modernize how your business operates.",
    },
    {
      icon: <FaRobot size={40} />,
      title: "AI & IoT Solutions",
      link: "/solution/AI&LOT",
      description:
        "Intelligent automation and connected devices that drive efficiency across your operations.",
    },
  ];

  const carouselRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const cardsPerView = 4;

  const scrollToSlide = (index) => {
    const maxIndex = Math.max(solutionCards.length - cardsPerView, 0);
    const clamped = Math.max(0, Math.min(index, maxIndex));
    setActiveSlide(clamped);
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.scrollWidth / solutionCards.length;
      carouselRef.current.scrollTo({ left: cardWidth * clamped, behavior: "smooth" });
    }
  };

  const carouselStyles = {
    section: {
      backgroundColor: "#eef2fb",
      padding: "70px 40px",
      textAlign: "center",
    },
    eyebrow: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginBottom: "10px",
    },
    title: {
      fontSize: "30px",
      fontWeight: 800,
      color: "#111827",
      margin: "0 0 12px 0",
    },
    subtitle: {
      fontSize: "16px",
      color: "#6b7280",
      maxWidth: "620px",
      margin: "0 auto 40px auto",
      lineHeight: 1.6,
    },
    trackWrap: {
      position: "relative",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    track: {
      display: "flex",
      gap: "24px",
      overflowX: "auto",
      scrollSnapType: "x mandatory",
      scrollBehavior: "smooth",
      padding: "6px",
    },
    card: {
      flex: "0 0 auto",
      width: "260px",
      scrollSnapAlign: "start",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "30px 24px",
      display: "flex",
      flexDirection: "column",
      textDecoration: "none",
      minHeight: "260px",
    },
    iconBox: {
      color: "#3b6df0",
      marginBottom: "18px",
    },
    cardTitle: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "8px",
    },
    divider: {
      width: "28px",
      height: "3px",
      backgroundColor: "#3b6df0",
      borderRadius: "2px",
      margin: "0 0 14px 0",
    },
    cardText: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.7,
    },
    navBtn: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "20px",
      color: "#1f2a44",
      zIndex: 2,
    },
    dotsWrap: {
      display: "flex",
      justifyContent: "center",
      gap: "8px",
      marginTop: "30px",
    },
    dot: (active) => ({
      width: "9px",
      height: "9px",
      borderRadius: "50%",
      backgroundColor: active ? "#3b6df0" : "#c9d6f5",
      cursor: "pointer",
    }),
  };

  const serviceCardStyles = {
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
      gap: "30px",
      margin: "60px 80px",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      overflow: "hidden",
      border: "1px solid #e3ebfd",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
    },
    image: {
      width: "100%",
      height: "200px",
      objectFit: "cover",
    },
    body: {
      padding: "20px 22px",
    },
    heading: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "8px",
    },
    text: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.6,
    },
  };

  return (
    <div>
      {/* Why Choose Our IT Services + Our Mission — side-by-side rectangle boxes, no images */}
      <div
        style={{
          margin: "100px 80px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "30px",
            flexWrap: "wrap",
          }}
        >
          {/* Why Choose Our IT Services */}
          <div
            style={{
              flex: "1 1 400px",
              backgroundColor: "#ffffff",
              border: "1px solid #e3ebfd",
              borderRadius: "14px",
              padding: "34px 30px",
            }}
          >
            <h2
              style={{
                fontSize: "1.6rem",
                marginBottom: "8px",
                color: "#111827",
                fontWeight: 700,
              }}
            >
              Why Choose Our IT Services
            </h2>
            <div
              style={{
                width: "40px",
                height: "3px",
                backgroundColor: "#3b6df0",
                borderRadius: "2px",
                margin: "0 0 18px 0",
              }}
            />
            <p
              style={{
                lineHeight: "1.8",
                fontSize: "1rem",
                color: "#4b5563",
              }}
            >
              The solutions we adopt for our portfolio are all chosen carefully
              and undergo extensive vetting and evaluation prior to inclusion.
              Our portfolio is designed to offer a full menu of IT business
              solutions. Optimizing our customers need and making them safe,
              secure and efficient is paramount.
              <br /> <br /> We always respect the needs and ideas of our
              customers and tailor solutions to meet their ongoing business
              objectives. By understanding that our customers are the most.
            </p>
          </div>

          {/* Our Mission */}
          <div
            style={{
              flex: "1 1 400px",
              backgroundColor: "#ffffff",
              border: "1px solid #e3ebfd",
              borderRadius: "14px",
              padding: "34px 30px",
            }}
          >
            <h2
              style={{
                fontSize: "1.6rem",
                marginBottom: "8px",
                color: "#111827",
                fontWeight: 700,
              }}
            >
              Our Mission
            </h2>
            <div
              style={{
                width: "40px",
                height: "3px",
                backgroundColor: "#3b6df0",
                borderRadius: "2px",
                margin: "0 0 18px 0",
              }}
            />
            <p
              style={{
                lineHeight: "1.8",
                fontSize: "1rem",
                color: "#4b5563",
              }}
            >
              At ORYYX DIGITAL SOLUTION, our mission is to empower businesses with exceptional, tailored IT solutions that drive long-term success. As a leading IT service provider and system integrator, we understand that each client has unique needs. We are committed to providing innovative and efficient solutions that not only meet those needs but also exceed expectations, enabling our clients to achieve their business objectives and thrive in today's dynamic environment.
            </p>
          </div>
        </div>

        {/* Stat boxes — centered row below both content boxes */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "40px",
          }}
        >
          {[
            { stat: "2+", label: "Years of Experience" },
            { stat: "100+", label: "Projects Delivered" },
            { stat: "24/7", label: "Support & Monitoring" },
            { stat: "98%", label: "Client Satisfaction" },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                flex: "0 1 220px",
                backgroundColor: "#ffffff",
                border: "1px solid #e3ebfd",
                borderRadius: "12px",
                padding: "24px 20px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#3b6df0", marginBottom: "6px" }}>
                {item.stat}
              </div>
              <div style={{ fontSize: "0.85rem", color: "#4b5563", fontWeight: 600 }}>
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/** Solutions Carousel — restyled to match the blue/white reference layout */}
      <section style={carouselStyles.section}>
        <div style={carouselStyles.eyebrow}>Our Solutions</div>
        <h2 style={carouselStyles.title}>Explore Our Core IT Solutions</h2>
        <p style={carouselStyles.subtitle}>
          From networking to AI, we deliver end-to-end technology solutions built around your
          business needs.
        </p>

        <div style={carouselStyles.trackWrap}>
          <button
            style={{ ...carouselStyles.navBtn, left: "-24px" }}
            onClick={() => scrollToSlide(activeSlide - 1)}
            aria-label="Previous"
          >
            ‹
          </button>

          <div className="solutions-track" style={carouselStyles.track} ref={carouselRef}>
            {solutionCards.map((item, index) => (
              <Link
                to={item.link}
                key={index}
                style={carouselStyles.card}
              >
                <div style={carouselStyles.iconBox}>{item.icon}</div>
                <h3 style={carouselStyles.cardTitle}>{item.title}</h3>
                <div style={carouselStyles.divider} />
                <p style={carouselStyles.cardText}>{item.description}</p>
              </Link>
            ))}
          </div>

          <button
            style={{ ...carouselStyles.navBtn, right: "-24px" }}
            onClick={() => scrollToSlide(activeSlide + 1)}
            aria-label="Next"
          >
            ›
          </button>
        </div>

        <div style={carouselStyles.dotsWrap}>
          {Array.from({ length: Math.max(solutionCards.length - cardsPerView + 1, 1) }).map((_, i) => (
            <span
              key={i}
              style={carouselStyles.dot(i === activeSlide)}
              onClick={() => scrollToSlide(i)}
            />
          ))}
        </div>
      </section>

      {/* Service Image Cards — restyled as clean blue/white rectangle boxes */}
      <div style={serviceCardStyles.grid}>
        {images.map((image, index) => (
          <div
            key={index}
            style={serviceCardStyles.card}
            onClick={() => openDialog(image)}
          >
            <img
              src={image}
              alt={`Service ${index + 1}`}
              style={serviceCardStyles.image}
            />
            <div style={serviceCardStyles.body}>
              <h3 style={serviceCardStyles.heading}>
                {[
                  "Data Center Virtualization & Computing",
                  "Enterprise Networking",
                  "Cybersecurity Solutions",
                  "Cloud & Applications",
                  "Managed Services",
                  "Physical Infrastructure Solutions"
                ][index]}
              </h3>
              <p style={serviceCardStyles.text}>
                {[
                  "Comprehensive solutions for data center virtualization, including application servers, file servers, database servers, compute servers, serverless compute, and unified storage solutions.",
                  "Encompasses routing and switching, wireless solutions, software-defined WAN, WAN optimization, and collaboration tools.",
                  "Robust cybersecurity solutions, including endpoint security, email security, cloud security, and compliance audits.",
                  "Cloud migration strategy & deployment, application adoption, compliance, licensing, and cloud security consulting.",
                  "24/7 managed services, including help desk, NOC/SOC monitoring, device as a service, and application monitoring.",
                  "Design and implement physical infrastructure solutions, including structured cabling, fiber optic cabling, and IoT solutions."
                ][index]}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Dialog Box */}
      {
        isDialogOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              animation: "fadeIn 0.5s ease",
            }}
            onClick={closeDialog}
          >
            <div
              style={{
                width: "80%",
                height: "80%",
                backgroundColor: "#fff",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={selectedImage}
                alt="Selected Service"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        )
      }

    </div >
  );
};

export default Service;